// src/features/dashboard/hooks/useDashboardContext.js
import { useAppStore } from '../../../store/useAppStore'
import { useBranchContext } from '../../../context/BranchContext'
import { useResolvedBusinessId } from '../../../hooks/useRole'
export function useDashboardContext() {
  const { isOwner, effectiveBranchId, hasBranches, loading: branchLoading } = useBranchContext()
  const { businessId, authLoading } = useResolvedBusinessId()
  const businessRecord = useAppStore((state) => state.business)

  const business =
    businessRecord?.id
      ? businessRecord
      : businessId
        ? { id: businessId, ...businessRecord }
        : null

  let accessIssue = null
  let loading = authLoading || branchLoading

  if (!authLoading && !businessId) {
    accessIssue = 'Business not found. Finish signup or sign in again.'
    loading = false
  } else if (!authLoading && !branchLoading) {
    loading = false
    if (!isOwner && !effectiveBranchId) {
      accessIssue = 'No branch assigned. Ask your owner to assign you to a branch.'
    } else if (isOwner && !hasBranches) {
      accessIssue = null
    }
  }

  return {
    business,
    businessId,
    branchId: effectiveBranchId,
    hasBranches,
    needsFirstBranch: isOwner && !hasBranches,
    loading,
    accessIssue,
  }
}
